import type { MenuButtonEvent } from '@ebay/ebayui-core/dist/components/ebay-menu-button/component';

export default class {
  onMenuSelect(event: MenuButtonEvent) {
    if ((event.el as HTMLDivElement).innerText === 'Sign out') {
      window.location.href = '/logout';
    }
  }
};
